







































































import Autocomplete from '@/components/Autocomplete.vue'
import PhoneTextField from '@/components/PhoneTextField.vue'
import Vue from 'vue'
import { getSmsClients, getSmsTags, sendSms } from '@/api/Sms/sms.api'
import SuccessSnackbar from '../TopUps/SuccessSnackbar.vue'
import { Params, VueForm } from '@/utils/interfaces'
import { productsEnum } from '@/utils/productsCode.constant'
import FlatCard from '~/components/FlatCard.vue'
import TextButton from '~/components/TextButton.vue'

export default Vue.extend({
  components: {
    PhoneTextField,
    SuccessSnackbar,
    appAutocomplete: Autocomplete,
    FlatCard,
    TextButton,
  },
  data() {
    return {
      rules: {
        required: (v: string) => !!v || this.$t('validation.field-required'),
      },
      crud: {
        content: '',
        phone_number: '',
        product: '' as string | number,
        tags: [],
      },
      specific: false,
      tagItems: [],
      loading: false,
      showSuccess: false,
      getClients: async (params?: Params) => {
        const response = await getSmsClients(params)
        response.data.results = response.data.results.map((item: any) => ({
          text: `${item.first_name} ${item.last_name} (${item.phone})`,
          ...item,
        }))
        return response
      },
      getSmsTags: (params?: Params) => getSmsTags({ ...params, limit: 100 }),
      clients: [],
    }
  },
  methods: {
    async onSend() {
      const form = this.$refs.form as VueForm
      if (!form.validate()) return
      try {
        this.loading = true
        const phone_numbers = this.clients.map((item: any) => item.phone)
        if (this.specific) {
          phone_numbers.push({
            phone_number: this.crud.phone_number,
          })
        }
        await sendSms({
          content: this.crud.content,
          product: productsEnum.SMS,
          phone_numbers,
          tags: this.crud.tags,
        })
        form.reset()
        this.crud.tags = []
        this.showSuccess = true
      } finally {
        this.loading = false
      }
    },
    onNativeInput(e: InputEvent) {
      if (e.data) {
        const code = e.data.charCodeAt(0)
        if (code > 127) {
          this.crud.content = this.crud.content.substring(
            0,
            this.crud.content.length - 1,
          )
          e.stopPropagation()
        }
      }
    },
  },
})
